/**
 * Example JavaScript singleton module
 */

var Slider = (function($) {
  function initSlider() {
    const heroSwiper = new Swiper(".home-slider", {
      slidesPerView: 1,
      loop: true,
      speed: 1000,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 4000, // cambia cada 4 segundos
        disableOnInteraction: false
      }
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   },
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev"
      //   }
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".home").length) {
      return;
    }

    initSlider();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Slider.init);
